import { createOrganisationRole } from '@infuse/api/iam/organisation';
import { useGenericCreateRole } from '@infuse/iam/role/mutations';

export const useCreateOrganisationRole = () => {
  return useGenericCreateRole({
    apiFn: createOrganisationRole
  });
};
